import { useEffect, useState, useContext } from 'react';
import { useMasterTracksStore } from '../store/masterTracks.store';
import { usePublicTracksStore } from '../store/publicTracks.store';
import { useLocation } from 'react-router-dom';
import { FirebaseContext } from '../components/Firebase';
import * as ROUTES from '../constants/routes';

const PublicTracksListener: React.FC = () => {
  const { initTracks: initMasterTracks, clearTracks: clearMasterTracks } = useMasterTracksStore();
  const { initTracks: initPublicTracks, clearTracks: clearPublicTracks } = usePublicTracksStore();
  const location = useLocation();
  const firebase = useContext(FirebaseContext);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    if (!firebase) return;
    const unsubscribe = firebase.auth.onAuthStateChanged(async (user: any) => {
      if (user) {
        // Force refresh the ID token to ensure Firestore has valid auth
        await user.getIdToken(true);
        setUser(user);
      } else {
        setUser(null);
        // Clear tracks on logout
        clearMasterTracks();
        clearPublicTracks();
      }
    });

    return () => unsubscribe();
  }, [firebase, clearMasterTracks, clearPublicTracks]);

  // Initialize the correct store based on current route
  useEffect(() => {
    if (!user || !firebase) return;

    const masterPaths = [ROUTES.PUBLIC_CATALOGUE, ROUTES.MASTER_LIBRARY];
    const publicPaths = [ROUTES.PUBLIC_LIBRARY];

    if (masterPaths.includes(location?.pathname)) {
      initMasterTracks(firebase);
    }
    if (publicPaths.includes(location?.pathname)) {
      initPublicTracks(firebase);
    }
  }, [user, location?.pathname, firebase, initMasterTracks, initPublicTracks]);

  return null;
};

export default PublicTracksListener;
